import type { ViewModeHandle } from "./viewModeHandle";
import type {
	ViewModeActionDefinition,
	ViewModeActionDescriptor,
	ViewModeIntent,
	ViewModeOperationResult,
	MaybeAsync
} from "./view-modes-section-types";

export class ViewModeActionHandle implements ViewModeActionDescriptor {
	public readonly key: string;

	public constructor(
		public readonly action: ViewModeActionDefinition,
		public readonly mode: ViewModeHandle
	) {
		if(!action.code) {
			throw new Error("view-mode-action requires a non-empty code.");
		}
		if(!action.label?.trim()) {
			throw new Error(`view-mode-action '${action.code}' requires a label.`);
		}

		this.key = `${mode.key}:${action.code}`;
	}

	public get code(): string {
		return this.action.code;
	}

	public get label(): string {
		return this.action.label;
	}

	public get icon(): string | undefined {
		return this.action.icon;
	}

	public get isIconOnly(): boolean {
		return this.action.iconOnly === true;
	}

	public get intent(): ViewModeIntent {
		return this.action.intent ?? "default";
	}

	public get targetMode(): string | undefined {
		return this.action.targetMode;
	}

	public get isVisible(): boolean {
		return this.action.visible !== false;
	}

	public get isDisabled(): boolean {
		return this.action.disabled === true;
	}

	public invoke(): MaybeAsync<ViewModeOperationResult> {
		return this.action.onInvoke?.({
			$action: this,
			$mode: this.mode
		});
	}

}
